import { gql, graphQueryBang } from "../../../shared/lib/graphql"

const QueryFragment = `
  id
  name
  module_name
  description
  weight
`

const replaceFragments = query =>
  query.replace(/QUERY_FRAGMENT/g, QueryFragment)

const QueriesQuery = replaceFragments(gql`
  query QueriesQuery($channel_module_name: String!) {
    channel(module_name: $channel_module_name) {
      queries {
        QUERY_FRAGMENT
      }
    }
  }
`)

const QueryAddMutation = replaceFragments(gql`
  mutation QueryAddMutation(
    $channel_module_name: String!
    $module_name: String!
    $name: String!
    $description: String!
  ) {
    queryCreate(
      input: {
        channel_module_name: $channel_module_name
        module_name: $module_name
        name: $name
        description: $description
      }
    ) {
      query {
        QUERY_FRAGMENT
      }
      errors {
        attribute
        message
      }
    }
  }
`)

const QueryUpdateMutation = replaceFragments(gql`
  mutation QueryUpdateMutation(
    $id: ID!
    $module_name: String!
    $name: String!
    $description: String!
    $weight: Int
  ) {
    queryUpdate(
      input: {
        id: $id
        module_name: $module_name
        name: $name
        description: $description
        weight: $weight
      }
    ) {
      query {
        QUERY_FRAGMENT
      }
      errors {
        attribute
        message
      }
    }
  }
`)

const QueryDeleteMutation = gql`
  mutation QueryDeleteMutation($id: ID!) {
    queryDelete(input: { id: $id }) {
      errors {
        attribute
        message
      }
    }
  }
`

const QueryCloneMutation = replaceFragments(gql`
  mutation QueryCloneMutation($id: ID!) {
    queryClone(input: { id: $id }) {
      query {
        QUERY_FRAGMENT
      }
      errors {
        attribute
        message
      }
    }
  }
`)

export function getQueries(channel_module_name) {
  return graphQueryBang(QueriesQuery, {
    channel_module_name,
  }).then(data => data.channel.queries)
}

export function queryAdd(channel_module_name, query) {
  return graphQueryBang(QueryAddMutation, {
    channel_module_name,
    name: query.name,
    module_name: query.module_name,
    description: query.description,
  }).then(data => data.queryCreate)
}

export function queryUpdate(query) {
  return graphQueryBang(QueryUpdateMutation, {
    id: query.id,
    name: query.name,
    module_name: query.module_name,
    description: query.description,
    weight: query.weight,
  }).then(data => data.queryUpdate)
}

export function queryDelete(query) {
  return graphQueryBang(QueryDeleteMutation, {
    id: query.id,
  }).then(data => data.queryDelete)
}

export function queryClone(query) {
  return graphQueryBang(QueryCloneMutation, {
    id: query.id,
  }).then(data => data.queryClone)
}
